/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createFileRoute } from '@tanstack/react-router'
import { useOpenChatSidebar } from '@web/src/features/chat/chat-layout/chat-mobile-sidebar-context'
import ChatRoomView from '@web/src/features/chat/chat-room-view/chat-room-view'
import { env } from '@web/src/lib/env.client'
import i18n from '@web/src/lib/intl/i18n'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import { z } from 'zod'

export const Route = createFileRoute('/(auth)/(chat-layout)/chat/$roomId/')({
  component: ChatRoomPage,
  validateSearch: z.object({
    message: z.string().optional(),
  }),
  head: () => {
    const t = i18n.t.bind(i18n)
    return seo({
      title: `${t('Chat')} | ${env.VITE_APP_NAME}`,
      description: t('Chat'),
      robots: robotsMetaForEnvironment({ all: 'noindex,nofollow' }),
      meta: [{ name: 'rating', content: 'adult' }],
    })
  },
})

function ChatRoomPage() {
  const { roomId } = Route.useParams()
  const { message } = Route.useSearch()
  const openSidebar = useOpenChatSidebar()

  return <ChatRoomView focusMessageId={message} onToggleSidebar={openSidebar ?? undefined} roomId={roomId} />
}
